import { inject } from "@angular/core";
import { type CanActivateFn, Router } from "@angular/router";
import { AuthService } from "@shared/services/auth.service";
import { environment } from "../../environments/environment";

/** Guard para servicio de autenticación */
export const authGuard: CanActivateFn = async (): Promise<boolean> => {
    /** Servicio de enrutamiento para manejar navegación y redirecciones */
    const router = inject(Router);

    /** Servicio de autenticación para validar tokens y gestionar sesiones */
    const authService = inject(AuthService);

    const urlParams = new URLSearchParams(window.location.search);
    const sid = urlParams.get('sid');
    authService.syncUserFromUrl(urlParams);

    // Verificar si estamos en la ruta raíz o con parámetros de consulta
    if (router.url === '/' || router.url.startsWith('/?')) {
        // Si hay un parámetro 'sid', validar el token
        if (sid) {
            const isValid = await authService.validateToken(sid);
            if (isValid) {
                // Limpiar la URL y permitir acceso
                window.history.replaceState({}, '', '/');
                router.navigate(['/']);
                return true;
            }
        }

        // Verificar si existe un token en sessionStorage
        if (sessionStorage.getItem('token')) return true;

        // Si no hay autenticación válida, redirigir a login externo
        window.location.href = environment.loginUrl;
        return false;
    }

    // Para otras rutas, permitir acceso
    return true;

}